'use client';

import { useState } from 'react';
import Icon from '@/components/ui/AppIcon';

interface Tool {
  id: string;
  name: string;
  description: string;
  icon: string;
  category: string;
}

interface QuickAccessToolsProps {
  tools: Tool[];
  onToolClick: (toolId: string) => void;
}

export default function QuickAccessTools({ tools, onToolClick }: QuickAccessToolsProps) {
  const [isHydrated, setIsHydrated] = useState(false);

  useState(() => {
    setIsHydrated(true);
  });

  if (!isHydrated) {
    return (
      <div className="bg-card rounded-lg border border-border p-6">
        <div className="h-6 bg-muted rounded w-1/2 mb-6"></div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {[1, 2, 3, 4].map((i) => (
            <div key={i} className="h-24 bg-muted rounded"></div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="bg-card rounded-lg border border-border p-6">
      <div className="flex items-center space-x-3 mb-6">
        <Icon name="WrenchScrewdriverIcon" size={24} className="text-accent" />
        <h3 className="font-headline text-lg font-semibold text-foreground">
          Quick Access Tools
        </h3>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {tools.map((tool) => (
          <button
            key={tool.id}
            onClick={() => onToolClick(tool.id)}
            className="group p-4 bg-muted rounded-lg border border-border hover:border-accent transition-all duration-300 hover:shadow-glow text-left"
          >
            <div className="flex items-start space-x-3">
              <div className="p-2 bg-accent/10 rounded-lg group-hover:bg-accent/20 transition-colors duration-300">
                <Icon
                  name={tool.icon as any}
                  size={20}
                  className="text-accent"
                />
              </div>
              <div className="flex-1">
                <h4 className="font-headline text-sm font-semibold text-foreground mb-1 group-hover:text-accent transition-colors duration-300">
                  {tool.name}
                </h4>
                <p className="font-body text-xs text-technical-gray line-clamp-2">
                  {tool.description}
                </p>
              </div>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}